/**************************************************
 * Nombre:       Formulario_Totales.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import caja from '../../Recursos/foto_caja.png'
import {obtenerValorProductos} from "../../CodNegocio/Pedido/obtenerValorProductos";

const Formulario_Totales = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Ya casi tu pedido hecho</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <img src={caja} width={'70%'} height={'auto'}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 0}}>
                    <Typography sx={{fontSize: 16}}>Valor Compra:
                        <span style={{marginLeft: 10, fontWeight: 'bold'}}>
                        {formatoMoneda(obtenerValorProductos(props.props.getValues('productos')))}
                    </span>
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: -2, mb: 0}}>
                    <Typography sx={{fontSize: 16}}>Valor Envio:
                        <span style={{marginLeft: 10, fontWeight: 'bold'}}>
                        {formatoMoneda(props.props.getValues('valorEnvio'))}
                    </span>
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', pt: 1, borderTop: 1}}>
                    <Typography sx={{fontSize: 20}}>Valor Total Pedido:
                        <span style={{marginLeft: 10, fontWeight: 'bold'}}>
                        {formatoMoneda(props.props.getValues('valorEnvio') + obtenerValorProductos(props.props.getValues('productos')))}
                    </span>
                    </Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Totales